import * as React from "react";
import { hot } from "react-hot-loader";
import {
  FeatureProvider,
  type FeatureProviderProps,
} from "@origin-digital/features";
import { config } from "./config";
import { Root } from "./root";
import { getFeatureProviderConfig } from "./utils/feature-toggle";

const FeatureProviderSafe =
  FeatureProvider as unknown as React.FunctionComponent<FeatureProviderProps>;

const Application = () => (
  <FeatureProviderSafe config={getFeatureProviderConfig(config)}>
    <Root />
  </FeatureProviderSafe>
);

export default process.env.NODE_ENV === "production"
  ? Application
  : hot(module)(Application);
